import React, { useState } from "react";

import { useGetLoggedIn, useGetProfileId } from "_common/hooks/auth";
import { getBaseURL }                      from "_common/utils";
import { updateShareCount }                from "_services/api/feed";

import Presentation from "./presentation";

const component = props => {
	const {
		game,
		isLeaderBoardLive,
		isProStream,
		localeKey,
		sessionDataId,
		tags,
		title,
		totalLikes = 0, // from videos/[id] page
		totalComments = 0, // from videos/[id] page
		isVideoLike,
		onClickLike = {},
		toggleCollapse = {},
		isFromVideos
	} = props;

	const userId     = useGetProfileId ();
	const isLoggedIn = useGetLoggedIn ();

	const [ anchorEl, setAnchorEl ] = useState ( null );
	const [ open, setOpen ]         = useState ( false );

	const handleClickOpen = event => {
		if ( !open ) {
			setAnchorEl ( event.currentTarget );
			setOpen ( previousOpen => !previousOpen );
		}
	  };

	const handleClickAway = () => {
		setOpen ( false );
	};

	const getSrc = () => {
		let shareLink;

		if ( isFromVideos )
			return shareLink = `${ getBaseURL () }/video/${ sessionDataId }`;

		shareLink = `${ getBaseURL () }/stream/${ sessionDataId }`;

		return shareLink;
	};

	const onClickShareItem = async () => {

		if ( isFromVideos && isLoggedIn ) {
			await updateShareCount ( { feedId: parseInt ( sessionDataId ), userId } );
		}

	};

	return (
		<Presentation
			anchorEl          = { anchorEl }
			game              = { game }
			getSrc            = { getSrc }
			handleClickAway   = { handleClickAway }
			handleClickOpen   = { handleClickOpen }
			isFromVideos      = { isFromVideos }
			isLeaderBoardLive = { isLeaderBoardLive }
			isProStream       = { isProStream }
			isVideoLike       = { isVideoLike }
			localeKey         = { localeKey }
			onClickLike       = { onClickLike }
			onClickShareItem  = { onClickShareItem }
			open              = { open }
			tags              = { tags }
			title             = { title }
			toggleCollapse    = { toggleCollapse }
			totalComments     = { totalComments }
			totalLikes        = { totalLikes }
		/>
	);
};

export default component;
